import { AttendanceLogs } from "./Attendance";

export const AttendanceReport = {
  "sections": [
    AttendanceLogs
  ]
}